import { Backdrop, Box, Button, Checkbox, CircularProgress, FormControlLabel, Grid, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { API, graphqlOperation } from 'aws-amplify';
import { SetOffModal, useSetOffModal } from '../../../../features';
import { defaultRowsPerPage, formatNumber, TRANSACTION_CONFIG } from '../../../../utils/common';
import { useTransactionModalHandle } from '../../../LedgerTransaction/hooks/useTransactionModalOpen';
import { listaccounttransactiondetailstotals, listAccountTransactionDetailsv3 } from '../../../../graphql';
import { headCell } from '../../newReports/data';
import TooltipComp from '../../eWayBill/toolTipComp';
import Listing from '../../../../components/listing';
import { formatUnixTimestamp } from '../../../../library';
import { updateTitle } from '../../../../redux/reducers/titleSlice';
import { LedgerTransactionModalv2 } from '../../../LedgerTransaction';
const LedgerNew = ({
  data,
  setTableData,
  accountid,
  count,
  // rowsPerPage,
  setdataCount,
  ledgersData,
  includeOpeningBalance,
  totalDebit,
  totalCredit,
  totalbalance,
}) => {
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  const { isOpen, transactionData, openModal: openSetOffModal, closeModal: closeSetOffModal } = useSetOffModal();
  const [page, setPage] = useState(0);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [debo, setDebo] = useState({});
  const [setoffData, updateSetoffData] = useState({});
  const [showSearch, setShowSearch] = useState(false);
  const [columnname, setColumnname] = useState('');
  const [setoff, updateSetoff] = useState(data[0]?.accounttypeflag === 1 || data[0]?.accounttypeflag === 2);
  const { transactionModalParams, openTransactionModal: fnOpenTransansactionModal } = useTransactionModalHandle();
  const { startTimeStamp, endTimeStamp } = dashboardData?.report;
  const dispatch = useDispatch();
  const handleColumnNameChange = (newColumnname) => {
    setColumnname(newColumnname);
  };
  function filterValidValues(data) {
    const isValidValue = (value) => {
      if (value === null || value === undefined || value === '') return false;
      if (typeof value === 'object' && !Array.isArray(value)) {
        const keys = Object.keys(value);
        return keys.length > 0 && keys.some((key) => value[key] !== '');
      }
      return true;
    };

    return Object.fromEntries(Object.entries(data).filter(([key, value]) => isValidValue(value)));
  }
  const handleSetOffClick = (e, row) => {
    e.stopPropagation();
    updateSetoffData(row);
    const voucherType = row.transactiontype === 'Journal' ? 'ManualJournal' : row.transactiontype;
    const config = TRANSACTION_CONFIG[voucherType] || undefined;

    const voucherId = config?.getTransactionId(row);
    // const voucherId = row.transactiontype === 'SalesInvoice' ? row.invoiceid : row.purchaseid;

    const voucherNumber = voucherType === 'OpeningBalance' ? 'OpeningBalance' : row.vouchernumber;

    openSetOffModal(voucherType, voucherId, voucherNumber);
  };

  const periodChange = async (account, from, to) => {
    try {
      setBackdropOpen(true);
      let response = await API.graphql(
        graphqlOperation(listAccountTransactionDetailsv3, {
          accountid: account,
          columnname: 'enteredtimestamp',
          searcharray: '[]',
          searchmode: 0,
          ordertype: 'asc',
          openingbalance: includeOpeningBalance === true ? 1 : 0,
          startdate: startTimeStamp,
          enddate: endTimeStamp,
          rowfrom: 0,
          limitno: rowsPerPage,
        })
      );
      const resCount = await API.graphql(
        graphqlOperation(listaccounttransactiondetailstotals, {
          accountid: account,
          startdate: startTimeStamp,
          openingbalance: includeOpeningBalance === true ? 1 : 0,
          enddate: endTimeStamp,
        })
      );
      // if (selectedTab !== 5) {
      setTableData((prevItems) => {
        const existingIndex = prevItems.findIndex((item) => item.accountid == account);

        const newItem = {
          data: response.data.listAccountTransactionDetailsv3,
          accountid: account,
          count: resCount.data.listaccounttransactiondetailstotals[0]?.transactioncount,
          credit: resCount.data.listaccounttransactiondetailstotals[0]?.totalcredit,
          debit: resCount.data.listaccounttransactiondetailstotals[0]?.totaldebit,
          total: resCount.data.listaccounttransactiondetailstotals[0]?.closingbalance,
        };

        // if (existingIndex !== -1) {
        // Replace existing record
        const updated = [...prevItems];
        updated[existingIndex] = newItem;

        return updated;
      });
    } catch (err) {
      console.log(err);
    } finally {
      setBackdropOpen(false);
    }
  };
  const processObject = (obj) => {
    const result = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const keys = Object.keys(value);
          if (keys.length > 1) {
            const secondKey = keys[1];
            if (secondKey === 'value') {
              obj[key] = value[secondKey];
            } else if (secondKey === 'to' || secondKey === 'max') {
              const fromValue = value['from'];
              const toValue = value['to'];
              const minValue = value['min'];
              const maxValue = value['max'];
              if (fromValue && toValue) {
                obj[key] = { [`${key}from`]: fromValue, [`${key}to`]: toValue };
              } else if (minValue || maxValue) {
                obj[key] = { [`${key}from`]: minValue, [`${key}to`]: maxValue };
              } else {
                obj[key] = { from: '', to: '' };
              }
            }
          }
        }
      }
    }
    return obj;
  };

  const processObject2 = (obj) => {
    const result = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        // Check if the value is an object and not an array or null
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const keys = Object.keys(value);

          // Check if the nested keys end with 'from' or 'to'
          const isFromTo = keys.every((k) => k.endsWith('from') || k.endsWith('to') || k.endsWith('min') || k.endsWith('max'));

          if (isFromTo) {
            // Flatten the object by directly assigning the inner fields to the result
            for (const innerKey in value) {
              if (value.hasOwnProperty(innerKey)) {
                result[innerKey] = value[innerKey];
              }
            }
          } else {
            // Keep the object as it is if it doesn't match the pattern
            result[key] = value;
          }
        } else {
          // Directly copy non-object fields
          result[key] = value;
        }
      }
    }
    return result;
  };
  function trimFlatObject(obj) {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value]));
  }
  const trimmed = trimFlatObject(debo);
  const removedFalsydeboValues = filterValidValues(trimmed);
  const changeObj = processObject(removedFalsydeboValues);
  const newObj = processObject2(changeObj);
  const lastObj = filterValidValues(newObj);

  // Get account name from ledgersData array, ensuring proper type matching
  const accName =
    ledgersData && Array.isArray(ledgersData) && ledgersData.length > 0
      ? ledgersData.find((acc) => String(acc.accountsid) === String(accountid))?.accountname
      : null;

  function hasExtraFields(obj) {
    const allowed = ['enteredtimestampfrom', 'enteredtimestampto'];
    return Object.keys(obj).some((key) => !allowed.includes(key));
  }
  const sortLedger = columnname ? columnname !== 'enteredtimestamp' : false;
  const searchLedger = hasExtraFields(lastObj) || sortLedger;
  const columns = setoff === false ? headCell.filter((c) => !c.field.includes('setoff')) : headCell;

  const voucherType = setoffData.transactiontype === 'Journal' ? 'ManualJournal' : setoffData.transactiontype;
  const config = TRANSACTION_CONFIG[voucherType] || undefined;
  const voucherId = config?.getTransactionId(setoffData);

  useEffect(() => {
    if (data[0]?.accounttypeflag === 1 || data[0]?.accounttypeflag === 2) {
      updateSetoff(true);
    } else {
      updateSetoff(false);
    }
  }, [data]);
  return (
    <Grid container sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      <Grid item xs={12} sm={6} md={4} lg={1.8}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {accountid === 3 || accountid === '3' ? (
            'Cash Book'
          ) : accountid === 39 || accountid === '39' ? (
            'Bank Book'
          ) : accName ? (
            <TooltipComp value={accName} bold={true} />
          ) : (
            `Account ${accountid}`
          )}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={0.5}>
        {/* {data && data.length > 1 && ( */}
        <Tooltip title="Search" placement="top">
          <Button
            sx={{
              borderWidth: '3px',
              marginLeft: '5px',
              marginBottom: '4px',
              borderColor: 'primary.main',
              borderStyle: 'solid',
              backgroundColor: showSearch === true && '#f3724a',
              whiteSpace: 'nowrap',
              fontWeight: 'bold',
              '&:active': {
                transform: 'scale(0.92)',
                boxShadow: 'inset 0px 0px 5px rgba(0, 0, 0, 0.4)',
              },
              '&:hover': {
                backgroundColor: showSearch ? '#f3724a' : 'white',
              },
              height: '28px',
              minWidth: '10px',
              width: '30px',
            }}
            variant="outlined"
          >
            <SearchIcon
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowSearch((prev) => !prev);
              }}
              sx={{ fontSize: 20 }}
            />
          </Button>
        </Tooltip>
        {/* )} */}
      </Grid>
      {data[0]?.accounttypeflag === 1 || data[0]?.accounttypeflag === 2 ? (
        <Grid item xs={12} sm={6} md={2} lg={1.7}>
          <FormControlLabel
            control={
              <Checkbox
                key={accName}
                id={`checkbox-${accName}`}
                size="small"
                checked={setoff}
                onChange={(e) => {
                  updateSetoff(e.target.checked);
                }}
                sx={{
                  m: 0.5,
                  p: 0,
                }}
              />
            }
            label="Enable Set-Off"
            labelPlacement="end"
            sx={{
              m: 0,
              '& .MuiFormControlLabel-label': {
                fontSize: { xs: '12px', sm: '14px' },
              },
            }}
          />
        </Grid>
      ) : (
        <Grid item xs={12} sm={6} md={2} lg={1.7}></Grid>
      )}

      <Grid item xs={12} sm={12} md={12} lg={8} sx={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
        {/* {data && data.length > 0 && ( */}
        <Grid item container spacing={2} justifyContent="flex-end">
          <Grid item xs="auto">
            {/* <span
                style={{
                  fontWeight: 'bold',
                  padding: '0px',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  whiteSpace: 'nowrap',
                }}
                 sx={{ fontWeight: 600, fontSize: { xs: "11px", sm: "16px" } }}
              > */}
            <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
              Total Dr: ₹ {formatNumber(totalDebit, false, true)}
            </Typography>
            {/* </span> */}
          </Grid>
          <Grid item xs="auto">
            {/* <span
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  whiteSpace: 'nowrap',
                }}
              >
                Total Cr: {formatNumber(totalCredit, false, true)}
              </span> */}
            <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
              Total Cr: ₹ {formatNumber(totalCredit, false, true)}
            </Typography>
          </Grid>
          <Grid item xs="auto">
            {/* <span
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  whiteSpace: 'nowrap',
                }}
              >
                Closing Balance: {formatNumber(totalbalance, false, true)}
                {totalDebit - totalCredit > 0 ? ' Dr' : ' Cr'}
              </span> */}
            <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
              Closing Balance: ₹ {formatNumber(totalbalance, false, true)}
              {totalbalance ? (totalDebit - totalCredit > 0 ? ' Dr' : ' Cr') : ''}
            </Typography>
          </Grid>
        </Grid>
        {/* )} */}
      </Grid>
      <Grid item xs={12} sx={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
        <Box
          sx={{
            // borderRadius: 2,
            '.MuiTableCell-root': {
              padding: '5px',
            },

            // marginY: '10px',
            marginBottom: '10px',
            width: '100%',
            maxWidth: '100%',
          }}
        >
          <Listing
            bodyData={data}
            setBodyData={setTableData}
            headData={columns}
            showSearch={showSearch}
            count={count + 1}
            accountid={accountid}
            setPage={setPage}
            includeOpeningBalance={includeOpeningBalance}
            setDataCount={setdataCount}
            countVariable="transactioncount"
            queryCount={listaccounttransactiondetailstotals}
            queryCountName="listaccounttransactiondetailstotals"
            rowsPerPage={rowsPerPage}
            page={page}
            query={listAccountTransactionDetailsv3}
            startTimeStamp={startTimeStamp}
            endTimeStamp={endTimeStamp}
            queryName="listAccountTransactionDetailsv3"
            ordertype="asc"
            debo={debo}
            setDebo={setDebo}
            searchArr={lastObj}
            setRowsPerPage={setRowsPerPage}
            onColumnNameChange={handleColumnNameChange}
            renderCell={({ row, field, value }) => {
              const fontSize = '13px';

              switch (field) {
                case 'enteredtimestamp':
                  const datee =
                    row['vouchertype'] === 'OpeningBalance' ? (
                      <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: fontSize }}>
                        {formatUnixTimestamp(startTimeStamp)}
                      </Typography>
                    ) : (
                      <Typography variant="body1" sx={{ fontSize: fontSize }}>
                        {formatUnixTimestamp(row['enteredtimestamp'])}
                      </Typography>
                    );

                  return datee;

                case 'oppositeaccountname':
                  return (
                    <Tooltip title={row['oppositeaccountname']} placement="bottom">
                      <Typography
                        align="left"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (row['vouchertype'] !== 'OpeningBalance') {
                            fnOpenTransansactionModal({
                              accountId: row['oppositeaccountid'],
                              startDate: startTimeStamp || null,
                              endDate: endTimeStamp || null,
                              includingOpeningBalance: includeOpeningBalance,
                            });
                          }
                        }}
                        sx={{
                          fontSize: fontSize,
                          textDecoration: row['vouchertype'] !== 'OpeningBalance' && 'underline',
                          cursor: row['vouchertype'] !== 'OpeningBalance' && 'pointer',
                          color: row['vouchertype'] !== 'OpeningBalance' && '#2196f3',
                          whiteSpace: 'nowrap',
                          maxWidth: { xs: '200px', sm: '100%' },
                          overflow: { xs: 'scroll', sm: 'hidden' },
                          scrollbarWidth: 'none', // For Firefox
                          '&::-webkit-scrollbar': {
                            display: 'none', // For Chrome, Safari
                          },
                        }}
                      >
                        {row['vouchertype'] === 'OpeningBalance' ? (
                          <Typography sx={{ fontWeight: 'bold', fontSize: fontSize }}>
                            {' '}
                            {row['vouchertype'].replace(/([a-z])([A-Z])/g, '$1 $2')}
                          </Typography>
                        ) : (
                          <Typography sx={{ fontSize: fontSize }}>
                            <a
                              onClick={(e) => e.preventDefault()}
                              href={`/LedgerTransactions/${row['oppositeaccountid']}`}
                              className="myLink"
                            >
                              {row['oppositeaccountname']}
                            </a>
                          </Typography>
                        )}
                      </Typography>
                    </Tooltip>
                  );
                case 'vouchertype':
                  return row['vouchertype'] === 'OpeningBalance' ? (
                    ''
                  ) : (
                    <Typography sx={{ fontSize: fontSize }}>{row['vouchertype'].replace(/([a-z])([A-Z])/g, '$1 $2')}</Typography>
                  );
                case 'vouchernumber':
                  return (
                    <Tooltip title={row['vouchertype'] === 'OpeningBalance' ? '' : row['vouchernumber']} placement="bottom">
                      <Typography
                        align="left"
                        onClick={(e) => {
                          e.stopPropagation();
                          const config = TRANSACTION_CONFIG[row['vouchertype']] || {
                            path: '',
                            getTransactionId: () => '',
                          };
                          const { path, getTransactionId } = config;
                          const link = path ? `/${path}?transaction=${getTransactionId(row)}` : '';
                          window.open(link);
                          dispatch(updateTitle(row['vouchernumber']));
                        }}
                        sx={{
                          fontSize: fontSize,
                          textDecoration: row['vouchertype'] !== 'OpeningBalance' && 'underline',
                          cursor: row['vouchertype'] !== 'OpeningBalance' && 'pointer',
                          color: row['vouchertype'] !== 'OpeningBalance' && '#2196f3',
                          whiteSpace: 'nowrap',
                          maxWidth: { xs: '200px', sm: '100%' },
                          overflow: { xs: 'scroll', sm: 'hidden' },
                          scrollbarWidth: 'none', // For Firefox
                          '&::-webkit-scrollbar': {
                            display: 'none', // For Chrome, Safari
                          },
                        }}
                      >
                        <Typography sx={{ fontSize: fontSize }}>
                          {/* <a
                              onClick={(e) => e.preventDefault()}
                              href={`/LedgerTransactions/${row['oppositeaccountid']}`}
                              className="myLink"
                            > */}
                          {row['vouchertype'] === 'OpeningBalance' ? '' : row['vouchernumber']}
                          {/* </a> */}
                        </Typography>
                        {/* {row['vouchertype'] === 'OpeningBalance' ? '' : row['vouchernumber']} */}
                      </Typography>
                    </Tooltip>
                  );
                case 'totaldebitamount':
                  return row['vouchertype'] === 'OpeningBalance' ? (
                    ''
                  ) : (
                    <Typography
                      sx={{
                        fontSize: fontSize,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {value ? formatNumber(value, false, true) : ''}
                    </Typography>
                  );
                case 'totalcreditamount':
                  return row['vouchertype'] === 'OpeningBalance' ? (
                    ''
                  ) : (
                    <Typography
                      sx={{
                        fontSize: fontSize,
                        textWrap: 'nowrap',
                      }}
                    >
                      {value ? formatNumber(value, false, true) : ''}
                    </Typography>
                  );
                case 'balance':
                  const val = formatNumber(row?.balance, true, true, row?.balancesign);
                  const shouldColorCrRed = row?.balancesign === -1 && val && val.includes('Cr');
                  const shouldColorDrRed = row?.balancesign === 1 && val && val.includes('Dr');

                  return (
                    <Typography
                      sx={{
                        fontWeight: row['vouchertype'] === 'OpeningBalance' ? 'bold' : 'normal',
                        fontSize: fontSize,
                      }}
                    >
                      {searchLedger ? (
                        ''
                      ) : shouldColorCrRed ? (
                        <span>
                          {val.replace('Cr', '')}
                          <span style={{ color: 'red' }}>Cr</span>
                        </span>
                      ) : shouldColorDrRed ? (
                        <span>
                          {val.replace('Dr', '')}
                          <span style={{ color: 'red' }}>Dr</span>
                        </span>
                      ) : (
                        val
                      )}
                    </Typography>
                  );
                case 'setoff':
                  if (setoff === false) {
                    return null;
                  }
                  const hasDebitValue = row.accounttypeflag === 1 && Number(row.totaldebitamount || 0);
                  const hasCreditValue = row.accounttypeflag === 2 && Number(row.totalcreditamount || 0);
                  return (
                    <>
                      {(row.transactiontype === 'OpeningBalance' && row.transactionid && Number(row.balance > 0)) ||
                      (row.transactiontype !== 'OpeningBalance' && (hasDebitValue || hasCreditValue)) ? (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={(e) => handleSetOffClick(e, row)}
                          // sx={{
                          //   // minWidth: '80px',
                          //   // fontSize: '0.75rem',
                          //   py: 0.5,
                          //   px: 1,
                          // }}
                          sx={{
                            minWidth: '80px',
                            fontSize: '0.75rem',
                            py: 0.5,
                            px: 1,
                            ...(row?.setoffbalance === 0
                              ? { color: 'green', borderColor: 'green' }
                              : { color: '#2196f3', borderColor: '#2196f3' }),
                            ...(row?.setoffbalance === 0
                              ? {
                                  '&:hover': {
                                    color: 'white',
                                    backgroundColor: 'green',
                                    borderColor: 'green',
                                  },
                                }
                              : {
                                  '&:hover': {
                                    color: 'white',
                                    backgroundColor: '#2196f3',
                                    borderColor: '#2196f3',
                                  },
                                }),
                          }}
                        >
                          {row?.setoffbalance === 0 ? 'Settled' : 'Set-Off'}
                        </Button>
                      ) : (
                        ''
                      )}
                    </>
                  );
                case 'setoffbalance':
                  return (
                    <Typography
                      sx={{
                        fontSize: fontSize,
                      }}
                    >
                      {formatNumber(value, false, true)}
                    </Typography>
                  );
                default:
                  return (
                    <Tooltip title={value} placement="bottom">
                      <Typography
                        sx={{
                          fontWeight: row['vouchertype'] === 'OpeningBalance' ? 'bold' : 'normal',
                          fontSize: fontSize,
                          maxWidth: '150px',
                          whiteSpace: 'nowrap',
                          overflow: { xs: 'scroll', sm: 'hidden' },
                        }}
                      >
                        {value}
                      </Typography>
                    </Tooltip>
                  );
              }
            }}
          />
        </Box>
        {transactionModalParams.accountId && <LedgerTransactionModalv2 {...transactionModalParams} />}
        {isOpen && (
          <SetOffModal
            open={isOpen}
            onClose={closeSetOffModal}
            voucherType={setoffData.vouchertype === 'Journal' ? 'ManualJournal' : setoffData.vouchertype}
            voucherId={voucherId}
            accountid={setoffData?.accountid}
            voucherNumber={setoffData?.vouchertype === 'OpeningBalance' ? 'OpeningBalance' : setoffData.vouchernumber}
            onSetOffSuccess={() => {
              periodChange(setoffData?.accountid, startTimeStamp, endTimeStamp);
            }}
          />
        )}
        {console.log(setoffData, 'setoffData')}
      </Grid>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Grid>
  );
};
export default LedgerNew;
